<template>
  <div>
    <vs-popup :title="$t('EditRole')" :active.sync="showModal">
      <form>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="roleCurrent.name"
              name="roleName"
              :label="$t('RoleName')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('roleName')">{{
              errors.first("roleName")
            }}</span>
          </div>
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="roleCurrent.englishName"
              name="roleEnglishName"
              :label="$t('EnglishName')"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('RoleEnglishName')"
              >{{ errors.first("RoleEnglishName") }}</span
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-checkbox
              disabled
              class="float-left"
              v-model="roleCurrent.isActive"
              >{{ $t("Active") }}</vs-checkbox
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right mb-4"
              @click.prevent="submitForm"
              :disabled="disabled"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    roleName: {
      required: "لطفا عنوان نقش را وارد نمایید.",
    },
    RoleEnglishName: {
      required: "لطفا نام انگلیسی را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "user-management-Roles-ModifyPopup",
  props: {
    show: { default: false },
    roleCurrent: {},
  },
  data() {
    return {
      popupTitle: "",
      disabled: false,
      model: {},
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      updateRole: "role/update",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.model = {
            id: this.roleCurrent.id,
            name: this.roleCurrent.name,
            englishName: this.roleCurrent.englishName,
          };
          this.disabled = true;
          if (this.model.id != null) {
            this.updateRole(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
        }
      });
    },
  },
};
</script>
